// React
import React, { useState, useCallback, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import { BundleItem, Quantity, Name, Toggle, ToggleText } from './styles'
import FocalImage from 'ui/components/FocalImage'

// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp as farChevronUp, faChevronDown as farChevronDown } from '@fortawesome/pro-regular-svg-icons'

// Shared
import NO_PRODUCT_IMAGE from '@assets/images/no-product-image.png'
import { withTranslation } from 'shared/utils/withTranslation'

const BundleContents = ({ data, products, photos, t }) => {
  const [open, setOpen] = useState(false)

  const handleToggle = useCallback(() => {
    setOpen((prev) => !prev)
  }, [])

  return (
    <Fragment>
      <Toggle onClick={handleToggle}>
        <ToggleText>
          {t('user.cart.bundle_contents')} ({data.length})
        </ToggleText>
        <FontAwesomeIcon icon={open ? farChevronUp : farChevronDown} />
      </Toggle>
      {open &&
        data.map((item) => {
          const product = products.getById(item.item_id)

          if (!product) return null

          const photo = photos.getById(product?.photo_id)

          return (
            <BundleItem key={product.id}>
              <FocalImage
                coordinates={photo?.coordinates ?? { x: 0, y: 0 }}
                url={photo?.url ?? NO_PRODUCT_IMAGE}
                size="32px"
              />
              <Quantity>{item.quantity}x</Quantity>
              <Name>{product.name}</Name>
            </BundleItem>
          )
        })}
    </Fragment>
  )
}

BundleContents.displayName = 'BundleContents'

BundleContents.propTypes = {
  data: PropTypes.array,
  products: PropTypes.object,
  photos: PropTypes.object,
  t: PropTypes.func
}

const mapStateToProps = (state, props) => {
  const products = state.orm.products
  const photos = state.orm.photos

  return { products, photos }
}

export default compose(withTranslation('user'), reduxConnect(mapStateToProps))(BundleContents)
